<mat-card class="tabs-wrapper card-wrapper mat-card-layout">
    <div class="title">
        <prl-label value="label.login.unsubscribe.title"/>
    </div>
    <div class="message">
        <label>{{affiliate}}</label>
        <prl-label value="label.login.unsubscribe.message"></prl-label>
    </div>
    <mx-button [buttonModel]="unsubscribeButton"></mx-button>
</mat-card>